import { convertToAbsoluteUrl } from '../stringUtils';

export class CacheManager {
    private cacheName: string;
    private cacheUrl: string;

    constructor(cacheName: string, cacheUrl: string) {
        this.cacheName = cacheName;
        this.cacheUrl = cacheUrl;
    }

    async saveToCache(data: any) {
        const request = new Request(this.cacheUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if ('caches' in window) {
            const cache = await caches.open(this.cacheName);
            await cache.put(request, new Response(JSON.stringify(data)));
        } else {
            console.log('The browser does not support caches.');
        }
    }

    async readFromCache() {
        if (!('caches' in window)) {
            throw new Error('The browser does not support caches.');
        }
        const response = await caches.match(this.cacheUrl);
        if (!response) {
            throw new Error('No data in cache');
        }
        return await response.json();
    }

    /**
     * 画像をキャッシュに保存する
     */
    saveImage = async (url: string, image: any) => {
        if (!('caches' in window)) {
            return url;
        }
        const cacheUrl = `/background?image=${btoa(convertToAbsoluteUrl(url))}`;
        const blob = await image.blob();
        const imageCache = await caches.open(this.cacheName);
        await imageCache.put(new Request(cacheUrl, { method: 'GET' }), new Response(blob));

        //キャッシュに保存したものを再取得
        const responseImage = await imageCache.match(cacheUrl);
        if (responseImage) {
            const blobImage = await responseImage.blob();
            return URL.createObjectURL(blobImage);
        } else {
            throw new Error('No data in cache');
        }
    };

    /**
     * キャッシュから画像を読み取る
     */
    readImage = async (url: string) => {
        if (!('caches' in window)) {
            throw new Error('The browser does not support caches.');
        }
        const cacheUrl = `/background?image=${btoa(convertToAbsoluteUrl(url))}`;
        const imageCache = await caches.open(this.cacheName);
        const responseImage = await imageCache.match(cacheUrl);
        if (responseImage) {
            const blobImage = await responseImage.blob();
            return URL.createObjectURL(blobImage);
        } else {
            throw new Error('No data in cache');
        }
    };
}
